import { Box } from "@mui/material";
import React, { useState } from "react";
import CustomQuantityField, {
  CustomQuantityFieldProps,
} from "../CustomQuantityField";
import CustomQuantityMenuItem, {
  CustomQuantityMenuItemProps,
} from "../CustomQuantityMenuItem";
import { Section } from "../Section";
import { Price } from "../types";
import interpolate from "../../../util/interpolate";

export type PricesSectionProps = {
  moq: number;
  price: Price | null;
  prices: Price[] | null;
  pricesIncTax: boolean;
  quantity: number;
  locale: string;
  handleCustomPricing: (p: Price) => void;
  handleCustomQuantity: (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  quantityError?: boolean;
  mode?: "list" | "dropdown";

  translations: {
    enterSize: string;
    customQuantityLabel: string;
    quantitySubtitle: string;
  } & CustomQuantityMenuItemProps["translations"] &
    CustomQuantityFieldProps["translations"];
};

const PricesSection = (props: PricesSectionProps) => {
  const [customQuantity, setCustomQuantity] = useState(
    !props.prices?.some((p) => p.quantity === props.quantity)
  );

  if (!props.prices) {
    return null;
  }

  const tr = interpolate(props.translations);
  const t = (k: keyof PricesSectionProps["translations"]): string => {
    return tr(k, { moq: props.moq });
  };

  const prices = props.prices.filter((p) => p.quantity >= p.moq)

  const quantityField = customQuantity ? (
    <CustomQuantityField
      locale={props.locale}
      price={props.price}
      moq={props.moq}
      quantity={props.quantity}
      handleCustomQuantity={props.handleCustomQuantity}
      translations={{
        quantityLabel: props.translations.quantityLabel,
        quantityHelperText: props.translations.quantityHelperText,
      }}
      quantityError={props.quantityError}
    />
  ) : null;

  const list = !props.mode
    ? {
        display: {
          xs: "none",
          md: "block",
        },
      }
    : props.mode === "list"
    ? { display: "block" }
    : { display: "none" };

  const mobile = !props.mode
    ? {
        display: {
          xs: "block",
          md: "none",
        },
      }
    : props.mode === "dropdown"
    ? { display: "block" }
    : { display: "none" };

  return (
    <Section
      number={3}
      title={t("quantityTitle")}
      subtitle={t("quantitySubtitle")}
      titlePadding
      data-section="Quantity"
    >
      <Box
        sx={{
          ...list,
        }}
      >
        <CustomQuantityMenuItem
          variant="desktop"
          customQuantity={customQuantity}
          pricesIncTax={props.pricesIncTax}
          setCustomQuantity={setCustomQuantity}
          prices={prices}
          locale={props.locale}
          quantity={props.quantity}
          handleCustomPricing={(ev) => {
            setCustomQuantity(false);
            props.handleCustomPricing(ev);
          }}
          translations={{
            incTax: props.translations.incTax,
            exTax: props.translations.exTax,
            save: props.translations.save,
            quantityTitle: props.translations.quantityTitle,
            customQuantityLabel: props.translations.customQuantityLabel,
          }}
        />
        {quantityField}
      </Box>

      <Box
        sx={{
          ...mobile,
          px: { md: "23px" },

          maxWidth: {
            xs: "100%",
            md: "276px",
          },
        }}
      >
        <CustomQuantityMenuItem
          variant="mobile"
          customQuantity={customQuantity}
          pricesIncTax={props.pricesIncTax}
          setCustomQuantity={setCustomQuantity}
          prices={prices}
          locale={props.locale}
          quantity={props.quantity}
          handleCustomPricing={(ev) => {
            setCustomQuantity(false);
            props.handleCustomPricing(ev);
          }}
          translations={{
            incTax: props.translations.incTax,
            exTax: props.translations.exTax,
            save: props.translations.save,
            quantityTitle: props.translations.quantityTitle,
            customQuantityLabel: props.translations.customQuantityLabel,
          }}
        />
        {quantityField}
      </Box>
    </Section>
  );

  //   } else {
  //     !props.isSample
  //       ? sections.push(
  //           <Section
  //             key={sections.length + 1}
  //             number={sections.length + 1}
  //             title={t("customQuantityLabel")}
  //             subtitle={t("quantitySubtitle")}
  //             titlePadding
  //             data-section="Quantity"
  //           >
  //             <PricingSkeleton />
  //           </Section>
  //         )
  //       : null;
  //   }
};

export default PricesSection;
